import { render } from 'preact';
import { App } from './app';
import './styles/app.css';

render(<App />, document.getElementById('app')!);
